var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import CheckApply from "~/components/visit-case/check-apply.vue";
import { Dependencies } from "~/core/decorator";
import { FlowTaskService } from "~/services/domain-service/flow-task.service";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
var LeaveCaseApply = /** @class */ (function (_super) {
    __extends(LeaveCaseApply, _super);
    function LeaveCaseApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            applyDescription: '',
            leaveDueDate: ''
        };
        _this.checkMessages = {};
        _this.rules = {
            applyDescription: { required: true, message: "请输入申请原因" },
            leaveDueDate: { required: true, message: "请选择留案到期日期" }
        };
        _this.submitLoading = false;
        _this.dialog = false;
        return _this;
    }
    LeaveCaseApply.prototype.emitClose = function () {
        this.resetDate();
    };
    /**
     * 提交
     */
    LeaveCaseApply.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["dataFrom"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            _this.commitNext();
        });
    };
    /**
     * 检查案件
     */
    LeaveCaseApply.prototype.commitNext = function () {
        var _this = this;
        this.flowTaskService
            .checkApplyCategory({ applyCategory: this.applyType })
            .subscribe(function (data) {
            // 0 拒绝，1 提示，2 通过
            if (data.status === 1) {
                _this.$confirm("该" +
                    _this.$dict.getDictName(_this.applyType, "ApplyCategory") +
                    "申请将直接生效，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(function () {
                    _this.submit();
                })
                    .catch(_this.error);
            }
            else if (data.status === 2) {
                _this.submit();
            }
        }, this.error);
    };
    /**
     * 提交接口调用
     */
    LeaveCaseApply.prototype.submit = function () {
        this.submitLoading = true;
        this.dataForm.caseIds = this.caseIds;
        this.dataForm.applyCategory = this.applyType;
        this.dataForm.leaveDueDate = this.$filter.dateFormat(this.dataForm.leaveDueDate);
        if (this.applyType === 'ASSIST_LEAVE_CASE') {
            // 协催留案
            this.caseApplyRecordService
                .applyAssistLeaveCase(this.dataForm)
                .subscribe(this.success, this.error);
        }
        else {
            // 正常留案
            this.caseApplyRecordService
                .applyLeaveCase(this.dataForm)
                .subscribe(this.success, this.error);
        }
    };
    /**
     * 申请成功
     */
    LeaveCaseApply.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.emitClose();
        }
    };
    /**
     * 失败
     */
    LeaveCaseApply.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 取消
     */
    LeaveCaseApply.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 继续提交
     */
    LeaveCaseApply.prototype.confirmSubmit = function () {
        this.dataForm.confirm = 1;
        this.submit();
    };
    /**
     * 数据重置
     */
    LeaveCaseApply.prototype.resetDate = function () {
        this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            applyDescription: '',
            leaveDueDate: ''
        };
        var form = this.$refs["dataFrom"];
        form.resetFields();
        this.checkMessages = {};
    };
    __decorate([
        Dependencies(FlowTaskService)
    ], LeaveCaseApply.prototype, "flowTaskService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], LeaveCaseApply.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop({ type: String })
    ], LeaveCaseApply.prototype, "applyType", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], LeaveCaseApply.prototype, "caseIds", void 0);
    __decorate([
        Emit('close')
    ], LeaveCaseApply.prototype, "emitClose", null);
    LeaveCaseApply = __decorate([
        Component({
            components: {
                CheckApply: CheckApply
            }
        })
    ], LeaveCaseApply);
    return LeaveCaseApply;
}(Vue));
export default LeaveCaseApply;
